import type { JSX } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { useUi } from './context';
import type { SHEETS, SheetName } from './sheets';

let loaded: { SHEETS: typeof SHEETS } | null = null;
let loading: Promise<{ SHEETS: typeof SHEETS }> | null = null;

export function preloadSheets(): Promise<{ SHEETS: typeof SHEETS }> {
  loading ??= import('./sheets').then((m) => (loaded = m));
  return loading;
}

export function LazySheet({ name }: { name: SheetName }): JSX.Element | null {
  const { store } = useUi();
  const [mod, setMod] = useState(loaded);
  useEffect(() => {
    if (loaded) return;
    preloadSheets()
      .then(setMod)
      .catch(() => {
        loading = null;
        store.sheet.value = 'none';
        store.toast.value = { key: 'error.sheet', id: Date.now() };
      });
  }, [store]);
  if (!mod) return null;
  const View = mod.SHEETS[name];
  return <View />;
}
